module.exports = __webpack_public_path__ + "static/media/PAI.996d036d.svg";